// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__cwfnc","header":"ReportDetails_header__Fq5qw","title":"ReportDetails_title__25d5_","left":"ReportDetails_left__1vB_Z"};